const env = process.env.APP_ENV

const commonVariables = require('./common_variables.js')

const environmentVariables = require(`./${env}`)

const variables = {...commonVariables.default, ...environmentVariables.default}

module.exports = variables
